import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged } from 'rxjs';
import { ACCOUNT_TYPE } from 'src/app/core/domain';
import { IProfileDetails } from 'src/app/core/domain/profile.model';
import { GlobalService } from 'src/app/core/service/global.service';
import { getProfileData } from 'src/app/core/state/profile';

@Component({
  selector: 'app-add-to-wishlist',
  templateUrl: './add-to-wishlist.component.html',
  styleUrls: ['./add-to-wishlist.component.scss']
})
export class AddToWishlistComponent implements OnInit, OnChanges {

  @Input() toUserUUID: string;
  @Input() userAccountType: ACCOUNT_TYPE;
  loader = false
  profileData: IProfileDetails;
  connectionItem;

  constructor(
    public globalService: GlobalService, private store: Store,
  ) { }

  ngOnInit(): void {
    this.store.pipe(select(getProfileData))
      .pipe(distinctUntilChanged()).subscribe((res) => {
        if (res) {
          this.profileData = res;
          this.fetchWishList()
        }
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.fetchWishList()
  }

  fetchWishList() {
    if (!this.toUserUUID || !this.userAccountType || !this.profileData) {
      return
    }
    this.globalService.getWhishlist({
      toUserUUID: this.profileData.id+'',
      userAccountType: this.profileData.accountType
    }).subscribe({
      next: res => {
        if(res.data) {
          const items = res.data.filter(e=>e.otherUser.uuid === this.toUserUUID)
          // console.log('wishlist', items)
          this.connectionItem = items?.[0]
        }
      },
      // SC-SAAS-FRONTEND-2W / SAN-1977 -- getWhishlist() already toasts and re-throws (a 401 is
      // handled by the http interceptor). Without an error callback a gateway 504 here reached
      // Angular's ErrorHandler as an unhandled error. Same no-op as partner-search-page (SAN-487).
      error: () => { },
    })
  }

  handleAddToWishlist() {
    if (!this.toUserUUID) {
      return
    }
    this.loader = true
    this.globalService.addToWhishlist(
      { toUserUUID: this.toUserUUID }
    ).subscribe({
      next: res => {
        this.loader = false
        this.fetchWishList()
      },
      // SAN-1977 -- the service already toasts the failure; without this the spinner stayed on
      // and the Save/Saved button stayed hidden until a reload.
      error: () => { this.loader = false },
    })
  }

  handleRemoveFromWishlist() {
    this.loader = true
    this.globalService.deleteWishlistEntry(
      { id: this.connectionItem.otherUser.uuid }
    ).subscribe({
      next: res => {
        this.loader = false
        this.fetchWishList()
      },
      // SAN-1977 -- same as handleAddToWishlist(): stop the spinner, the service already toasted.
      error: () => { this.loader = false },
    })
  }

}
